var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.initialFlag
      ? _c("div", { staticClass: "initial" }, [_vm._m(0)])
      : _c("div", [
          _vm.adminView || _vm.partnerView
            ? _c("div", [
                _vm.currentUser != null
                  ? _c("div", [
                      _vm.publicRoute
                        ? _c(
                            "div",
                            [
                              _c("link", {
                                attrs: {
                                  rel: "stylesheet",
                                  type: "text/css",
                                  href:
                                    "/static/front/bootstrap/dist/css/bootstrap.min.css"
                                }
                              }),
                              _vm._v(" "),
                              _c("BusinessPanel", { staticClass: "test1" }),
                              _vm._v(" "),
                              _c("PublicPanel", { staticClass: "test2" })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("link", {
                                attrs: {
                                  rel: "stylesheet",
                                  type: "text/css",
                                  href:
                                    "/static/admin/bootstrap/css/bootstrap.min.css"
                                }
                              }),
                              _vm._v(" "),
                              _vm.adminView ? _c("AdminPanel") : _vm._e(),
                              _vm._v(" "),
                              _vm.partnerView ? _c("PartnerPanel") : _vm._e()
                            ],
                            1
                          )
                    ])
                  : _vm._e()
              ])
            : _c(
                "div",
                [
                  _c("link", {
                    attrs: {
                      rel: "stylesheet",
                      type: "text/css",
                      href: "/static/front/bootstrap/dist/css/bootstrap.min.css"
                    }
                  }),
                  _vm._v(" "),
                  _vm.verifyEmailRoute ? _c("EmailVerify") : _vm._e(),
                  _vm._v(" "),
                  (_vm.businessView || _vm.publicRoute) && !_vm.verifyEmailRoute
                    ? _c("BusinessPanel")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentUser == null &&
                  !_vm.publicRoute &&
                  !_vm.widgetRoute &&
                  !_vm.forgotPasswordRoute &&
                  !_vm.verifyEmailRoute
                    ? _c("Login")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentUser == null &&
                  !_vm.publicRoute &&
                  !_vm.widgetRoute &&
                  _vm.forgotPasswordRoute
                    ? _c("ForgotPassword")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.trialUserRoute ? _c("TrialRegistration") : _vm._e(),
                  _vm._v(" "),
                  _vm.publicRoute ? _c("PublicPanel") : _vm._e(),
                  _vm._v(" "),
                  _vm.widgetRoute ? _c("WidgetsPanel") : _vm._e()
                ],
                1
              )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "load-bg" }, [
      _c("div", { staticClass: "load" }, [
        _c("hr"),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "loadback" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 